<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 class="">KRABICE</h2>
        <div class="flex align-items-center">
            <router-link to="/mod-stock/boxies/0" class="mr-2">
              <PrimevueButton label="Pridať krabicu" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>

        </div>
      </div>
      <DataTable
          
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.boxies"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          v-model:selection="this.selectedBox"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="showDetail(this.selectedBox.id)"
          tableStyle="min-width: 30rem"
          scrollable
          :virtualScrollerOptions="{ itemSize: 40 }"
          :scrollHeight="`${this.vh - 420}px`"
      >
      <!--scrollable 
         :virtualScrollerOptions="{ itemSize: 100 }"
          :scrollHeight="`${this.vh - 420}px`"           
      -->
        <template #header>
          <div class="flex justify-content-end" >
            <IconField iconPosition="left">
              <InputIcon>
                <i class="pi pi-search mr-2"/>
              </InputIcon>
              <InputText style="min-width: 6rem" v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
            </IconField>
          </div>
        </template>

        <Column field="code" header="Kód"
                filterField="boxNumber"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '3rem' }" style="min-width: 6%">
          <template #body="slotProps">
            {{ slotProps.data.code }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 3rem"/>
          </template>
        </Column>
        
        <Column field="location" header="Umiestnenie"
                filterField="location"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '5rem' }" style="min-width: 8%">
          <template #body="slotProps">
            {{ slotProps.data.location }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>
 
        <Column field="order.orderCode" header="Objednávka"
                filterField="orderCode"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '4rem' }" style="min-width: 8%">
          <template #body="slotProps">
            {{ slotProps.data.order.orderCode }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 4rem"/>
          </template>
        </Column>

        <Column field="customer.lastName" header="Zákazník"
                filterField="customer"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 8%">
          <template #body="slotProps">
            {{ slotProps.data.customer.lastName }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>

        <Column field="opened" header="Stav">
               
          <template #body="slotProps">
            
            <PrimevueTag class="p-1 font-medium text-base justify-content-center" 
                       :value="slotProps.data.opened ? 'otvorená' : 'zatvorená'"
                       :severity="slotProps.data.opened ? 'success' : 'danger'"
                       rounded
            />
          </template>

        </Column>

        <Column header="">
          <template #body="slotProps">

            <PrimevueButton type="button" v-tooltip.top="{ value: 'Odstránenie krabice' }" icon="pi pi-trash" @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>
            <!--
            <a  @click="confirmDelete(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Odstrániť" text raised icon="pi pi-trash" severity="danger"/>
             </a>
             -->
          </template>
        </Column>
      </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

import PrimevueTag from 'primevue/tag';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
//import Utils from '@/components/utils';
//import {emiter} from '../main';

export default {
  components: {
    DataTable,
    Column,
    PrimevueTag,
    IconField,
    InputIcon,
    PrimevueButton

  },
  name: "BoxList",
  data() {
    return {
      store,
      vh: 0,
      selectedBox: null,
      boxies: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        boxNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        location: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderCode: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customer: {value: null, matchMode: FilterMatchMode.CONTAINS},

      },
      filterFields: [  {field: 'Code',value: ""},
                       {field: 'OrderId__OrderCode',value: ""},
                       {field: 'Location',value: ""},
                       {field: 'CustomerId__LastName',value: ""},                       
                       
                    ],
      globalFilterFields: ['Code', 'Location', 'OrderId__OrderCode','CustomerId__LastName'],
      //categories: [],
      //selectedCategory: 0,
      //categoryLabels: [],
      loading: true,
      //lazyParams: [],
      pagination: {
        first: 0,
        rows: 100,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },
  beforeMount() {
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      
      this.setDynamicHeight(); 
      
      window.addEventListener("resize", this.setDynamicHeight);
      
      this.initFilters()

      //if (store.user.admin) {
      //  this.globalFilterFields = ['productCode', 'ModifiedUser__LastName','CustomerId__Company', 'CustomerLastName', 'CurrentState__Name']
      //}
     
      this.loadComponent()
    }
  },
  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

 
    showDetail(boxId:number) {
      router.push('/mod-stock/boxies/' + String(boxId))
    },
    confirmDelete(boxId:number) {
      this.$confirm.require({
          message: 'Naozaj chcete odstrániť krabicu?',
          header: 'Odstránenie krabice',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.deleteBox(boxId)
          },

      });
    },
    deleteBox(boxId:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/box/" + String(boxId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Krabicu sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                //this.boxies = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Krabica bola odstránená",
                  position: "bottom"
                })
                this.initFilters()
                this.loadComponent()
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení krabice: ' + error)
            })
      //}
    },

    onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },

    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      //console.log('Load component',this.pagination.filters);
      //this.routeByType = Utils.getMessageRoute(this.store.basicUrlFilterproducts,this.routeParams)

      this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "box"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;

    },
    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'Code',value: event.filters.boxNumber.value ? event.filters.boxNumber.value : ""},
                                                    {field: 'Location',value: event.filters.location.value ? event.filters.location.value: ""},
                                                    {field: 'OrderId__OrderCode',value: event.filters.orderCode.value ? event.filters.orderCode.value: ""},
                                                    {field: 'CustomerId__LastName',value: event.filters.customer.value ? event.filters.customer.value: ""},
                                                   
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },
    loadLazyData(route,params) {
      
      this.loading = true;
      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("POST",params.filters))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
              //console.error("error:", responseData.message);
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: "Zoznam krabíc sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.boxies = responseData.data;

                }else{
                    notie.alert({
                    type: 'info',
                    text: "Zoznam produktov je prázdny",
                    position: "top"
                  })
                  this.boxies = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            //alert('Error fetching data: ' + error);
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní krabíc: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>